import HeaderDesktop from "./header-desktop/";
import HeaderMobile from "./header-mobile/";
import Hamburger from "./hamburger/";

const modul = angular
    .module("headerComponents", [])

    .directive("headerDesktop", HeaderDesktop)
    .directive("headerMobile", HeaderMobile)
    .directive("hamburger", Hamburger);

export default modul.name;
